if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }
      
    }

    changeSlide(direction) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}

/* openclawEipProofPatch20260511: client-side bridge while Shopify page_cache refreshes canonical edible-image HTML. */
(function openclawEipProofPatch20260511() {
  try {
    if (window.location.pathname !== '/pages/edible-image-printing') return;
    var root = document.querySelector('.eip-page');
    if (!root || root.querySelector('#proof-heading')) return;
    var steps = root.querySelector('.eip-steps');
    if (!steps) return;
    var style = document.createElement('style');
    style.textContent = '.eip-proof-grid{display:grid;gap:16px;align-items:stretch}.eip-proof-photo{overflow:hidden;min-height:100%;padding:0}.eip-proof-photo img{display:block;width:100%;height:100%;min-height:260px;object-fit:cover}.eip-proof-copy{display:grid;gap:12px}.eip-proof-copy .eip-card{box-shadow:none}.eip-proof-stat{display:grid;gap:3px;padding:14px 15px;background:#fffdf8;border:1px solid var(--line);border-radius:16px}.eip-proof-stat strong{color:var(--pink-dark);font-family:\'Fraunces\',Georgia,serif;font-size:clamp(1.45rem,4vw,2.2rem);line-height:1}.eip-proof-stat span{color:var(--muted)}.eip-proof-cta{display:flex;flex-wrap:wrap;gap:10px;align-items:center;margin-top:2px}.eip-proof-cta .eip-button{min-width:190px}@media (min-width:860px){.eip-proof-grid{grid-template-columns:.9fr 1.1fr}}';
    document.head.appendChild(style);
    var section = document.createElement('section');
    section.className = 'eip-section';
    section.setAttribute('aria-labelledby', 'proof-heading');
    section.innerHTML = '<div class="eip-section-head"><span class="eip-kicker">Real counter proof</span><h2 id="proof-heading">This is the same edible image service customers use in the store.</h2><p>Online requests are new. The printing service is not. Gloria\'s current sales history includes 1,056 edible image sheets and circles, most handled over the counter by people who needed the print to look right on a real cake.</p></div><div class="eip-proof-grid"><figure class="eip-card eip-proof-photo"><img src="https://cdn.shopify.com/s/files/1/0860/3372/7770/files/counter-edible-image-station.jpg?v=1774039965" alt="The edible image printing station at Gloria\'s Cake and Candy Supplies in Culver City" width="1280" height="960" loading="lazy"></figure><div class="eip-proof-copy"><div class="eip-proof-stat"><strong>1,056</strong><span>edible image sheets and circles in Gloria\'s sales history.</span></div><div class="eip-card"><h3>We check the file before printing.</h3><p>If your photo is blurry, cropped too tight, or the size does not match your cake, we follow up before it goes on edible paper.</p></div><div class="eip-card"><h3>You do not have to know the exact size.</h3><p>Tell us round cake, sheet cake, cupcakes, cookies, or "not sure." We match the print to the dessert and confirm the price first.</p></div><div class="eip-proof-cta"><a class="eip-button" href="?utm_source=onsite&amp;utm_medium=edible_service&amp;utm_campaign=eip_proof_handoff_may11&amp;utm_content=proof_section#eipUploadBlock" data-eip-track="proof_section_request">Send your photo</a><a class="eip-button-secondary" href="tel:3232898807" data-eip-track="proof_section_phone">Call first</a></div></div></div>';
    steps.insertAdjacentElement('afterend', section);
  } catch (error) {
    console.warn('openclawEipProofPatch20260511 failed', error);
  }
})();


/* openclawEipProofPatch20260511Full: client-side bridge while Shopify page_cache refreshes canonical edible-image HTML. */
(function openclawEipProofPatch20260511Full() {
  try {
    if (window.location.pathname !== '/pages/edible-image-printing') return;
    var root = document.querySelector('.eip-page');
    if (!root || root.querySelector('#proof-heading')) return;
    var steps = root.querySelector('.eip-steps');
    if (!steps) return;
    var style = document.createElement('style');
    style.textContent = '.eip-proof-grid{display:grid;gap:16px;align-items:stretch}.eip-proof-photo{overflow:hidden;min-height:100%;padding:0}.eip-proof-photo img{display:block;width:100%;height:100%;min-height:260px;object-fit:cover}.eip-proof-copy{display:grid;gap:12px}.eip-proof-copy .eip-card{box-shadow:none}.eip-proof-stat{display:grid;gap:3px;padding:14px 15px;background:#fffdf8;border:1px solid var(--line);border-radius:16px}.eip-proof-stat strong{color:var(--pink-dark);font-family:\'Fraunces\',Georgia,serif;font-size:clamp(1.45rem,4vw,2.2rem);line-height:1}.eip-proof-stat span{color:var(--muted)}.eip-proof-cta{display:flex;flex-wrap:wrap;gap:10px;align-items:center;margin-top:2px}.eip-proof-cta .eip-button{min-width:190px}@media (min-width:860px){.eip-proof-grid{grid-template-columns:.9fr 1.1fr}}';
    document.head.appendChild(style);
    var section = document.createElement('section');
    section.className = 'eip-section';
    section.setAttribute('aria-labelledby', 'proof-heading');
    section.innerHTML = '<div class="eip-section-head"><span class="eip-kicker">Real counter proof</span><h2 id="proof-heading">This is the same edible image service customers use in the store.</h2><p>Online requests are new. The printing service is not. Gloria\'s current sales history includes 1,056 edible image sheets and circles, most handled over the counter by people who needed the print to look right on a real cake.</p></div><div class="eip-proof-grid"><figure class="eip-card eip-proof-photo"><img src="https://cdn.shopify.com/s/files/1/0860/3372/7770/files/counter-edible-image-station.jpg?v=1774039965" alt="The edible image printing station at Gloria\'s Cake and Candy Supplies in Culver City" width="1280" height="960" loading="lazy"></figure><div class="eip-proof-copy"><div class="eip-proof-stat"><strong>1,056</strong><span>edible image sheets and circles in Gloria\'s sales history.</span></div><div class="eip-card"><h3>We check the file before printing.</h3><p>If your photo is blurry, cropped too tight, or the size does not match your cake, we follow up before it goes on edible paper.</p></div><div class="eip-card"><h3>You do not have to know the exact size.</h3><p>Tell us round cake, sheet cake, cupcakes, cookies, or "not sure." We match the print to the dessert and confirm the price first.</p></div><div class="eip-proof-cta"><a class="eip-button" href="?utm_source=onsite&amp;utm_medium=edible_service&amp;utm_campaign=eip_proof_handoff_may11&amp;utm_content=proof_section#eipUploadBlock" data-eip-track="proof_section_request">Send your photo</a><a class="eip-button-secondary" href="tel:3232898807" data-eip-track="proof_section_phone">Call first</a></div></div></div>';
    steps.insertAdjacentElement('afterend', section);
  } catch (error) {
    console.warn('openclawEipProofPatch20260511Full failed', error);
  }
})();
